import React, { useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import ScoreUploaderWizard from "../../../components/admin/score-uploader/ScoreUploaderWizard";
import adminHelper from "../../../helpers/adminHelper";
import AppContext from "../../../state/AppContext";
import UserContext from "../../../state/UserContext";
import AppRoutes from "../../AppRoutes";
import { MainContainer } from "../../../components/layout";
import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import permissionHelper from "../../../helpers/permissionHelper";

const ScoreUploaderPage: React.FC = () => {
  const navigate = useNavigate();
  const appContext = useContext(AppContext);
  const userContext = React.useContext(UserContext);

  useEffect(() => {
    // Redirect user to their journey page if they don't have permission
    if (
      !permissionHelper.userHasEitherPermission(
        userContext,
        "CanUploadExternalScores",
        "UPLOAD-EXTERNAL-SCORES"
      )
    ) {
      navigate(AppRoutes.yourJourney.root);
    }

    appContext.setPageTitle("External Score Uploader");
    appContext.setShowPageTitleAccent(true);
  }, [navigate]);

  return (
    <MainContainer>
      <div className="pt-2 hover:underline mb-2">
        <Link
          to={AppRoutes.admin.root}
          className="flex items-center text-gray-600"
        >
          <FontAwesomeIcon size="xs" icon={faChevronLeft} />
          <span className="pl-1.5">Back</span>
        </Link>
      </div>

      <ScoreUploaderWizard />
    </MainContainer>
  );
};

export default ScoreUploaderPage;
